import * as types from './coOpActionTypes';
import { CoOpActionKeys as keys } from './coOpActionKeys';
import { getFiscalYear } from '../../utils/fiscalYear';
import { ICoOpCampaignType, ICoOpState } from '../lookups';
import {
  ICoOpChangeStateRequest,
  ICoOpDealerEstimate,
  ICoOpGlobalSettings,
  ICoOpRegionBudget,
  ICoOpRequest,
  ICoOpRequestStatus,
  ICoOpSalesDistrictBudget,
  INewCoOpRequest
  } from './coOpInterfaces';

export const coOpActionCreators = {
  deleteCampaignType: (campaignTypeId: number): types.DeleteCoOpCampaignType => ({
    payload: { campaignTypeId },
    type: keys.DELETE_COOP_CAMPAIGN_TYPE
  }),
  fetchDealerEstimates: (fiscalYear: string, businessEntityId?: number): types.FetchCoOpDealerEstimates => ({
    payload: { businessEntityId, fiscalYear },
    type: keys.FETCH_COOP_DEALER_ESTIMATES
  }),
  fetchDealerRequests: (accountNum: string): types.FetchCoOpDealerRequests => ({
    payload: { accountNum },
    type: keys.FETCH_COOP_DEALER_REQUESTS
  }),
  fetchGlobalSettings: (fiscalYear?: string): types.FetchCoOpGlobalSettings => ({
    payload: { fiscalYear: fiscalYear ? fiscalYear : getFiscalYear() },
    type: keys.FETCH_COOP_GLOBAL_SETTINGS
  }),
  fetchRegionBudgets: (fiscalYear?: string): types.FetchCoOpRegionBudgets => ({
    payload: { fiscalYear: fiscalYear ? fiscalYear : getFiscalYear() },
    type: keys.FETCH_COOP_REGION_BUDGETS
  }),
  fetchRequest: (coOpRequestId: number): types.FetchCoOpRequest => ({
    payload: { coOpRequestId },
    type: keys.FETCH_COOP_REQUEST
  }),
  fetchRequests: (fiscalYear: string, finance: boolean = false): types.FetchCoOpRequests => ({
    payload: { fiscalYear, finance },
    type: keys.FETCH_COOP_REQUESTS
  }),
  fetchRequestStatuses: (coOpRequestId: number): types.FetchCoOpRequestStatuses => ({
    payload: { coOpRequestId },
    type: keys.FETCH_COOP_REQUEST_STATUSES
  }),
  fetchSalesDistrictBudget: (salesDistricts: string[], fiscalYear?: string): types.FetchCoOpSalesDistrictBudgets => ({
    payload: { fiscalYear: fiscalYear ? fiscalYear : getFiscalYear(), salesDistricts },
    type: keys.FETCH_COOP_SALESDISTRICT_BUDGETS
  }),
  setActiveStatus: (payload: ICoOpRequestStatus): types.SetCoOpActiveStatus => ({
    payload,
    type: keys.SET_COOP_ACTIVE_STATUS
  }),
  setDealerEstimates: (payload: ICoOpDealerEstimate[]): types.SetCoOpDealerEstimates => ({
    payload,
    type: keys.SET_COOP_DEALER_ESTIMATES
  }),
  setGlobalSettings: (payload: ICoOpGlobalSettings): types.SetCoOpGlobalSettings => ({
    payload,
    type: keys.SET_COOP_GLOBAL_SETTINGS
  }),
  setRegionBudgets: (payload: ICoOpRegionBudget[]): types.SetCoOpRegionBudgets => ({
    payload,
    type: keys.SET_COOP_REGION_BUDGETS
  }),
  setRequests: (payload: ICoOpRequest[]): types.SetCoOpRequests => ({ payload, type: keys.SET_COOP_REQUESTS }),
  setRequestStatuses: (payload: {
    coOpRequestId: number;
    statuses: ICoOpRequestStatus[];
  }): types.SetCoOpRequestStatuses => ({
    payload,
    type: keys.SET_COOP_REQUEST_STATUSES
  }),
  setSalesDistrictBudgets: (payload: ICoOpSalesDistrictBudget[]): types.SetCoOpSalesDistrictBudgets => ({
    payload,
    type: keys.SET_COOP_SALESDISTRICT_BUDGETS
  }),
  updateCampaignType: (payload: ICoOpCampaignType): types.UpdateCoOpCampaignType => ({
    payload,
    type: keys.UPDATE_COOP_CAMPAIGN_TYPE
  }),
  updateDealerEstimate: (payload: ICoOpDealerEstimate): types.UpdateCoOpDealerEstimate => ({
    payload,
    type: keys.UPDATE_COOP_DEALER_ESTIMATE
  }),
  updateGlobalSettings: (payload: ICoOpGlobalSettings): types.UpdateCoOpGlobalSettings => ({
    payload,
    type: keys.UPDATE_COOP_GLOBAL_SETTINGS
  }),
  updateRegionSettings: (payload: ICoOpRegionBudget[]): types.UpdateCoOpRegionBudgets => ({
    payload,
    type: keys.UPDATE_COOP_REGION_BUDGETS
  }),
  updateRequest: (payload: INewCoOpRequest): types.UpdateCoOpRequest => ({
    payload,
    type: keys.UPDATE_COOP_REQUEST
  }),
  updateSalesDistrictBudgets: (payload: ICoOpSalesDistrictBudget[]): types.UpdateCoOpSalesDistrictBudgets => ({
    payload,
    type: keys.UPDATE_COOP_SALESDISTRICT_BUDGETS
  }),
  updateState: (payload: ICoOpState): types.UpdateCoOpState => ({ payload, type: keys.UPDATE_COOP_STATE }),
  updateStatus: (payload: ICoOpChangeStateRequest): types.UpdateCoOpStatus => ({
    payload,
    type: keys.UPDATE_COOP_STATUS
  })
};
